import React from "react";
import pom2089 from "../../images/new/artist/pom2089.png";
import darlyn from "../../images/new/artist/darlyn.png";
import galaxy from "../../images/new/artist/galaxy.png";
import reckless from "../../images/new/artist/reckless.png";
import blogSubImage from "../../images/blog-author-avatar.png";
import buttonIcon from '../../images/button-icon.svg';
import { useEffect } from "react";
// importing aos
import AOS from "aos";
import "aos/dist/aos.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
const options = {
  center: false,
  items: 1,
  loop: true,
  margin: 50,
  nav: false,
  autoplay: false,
  autoWidth: true,
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 3,
    },

    1000: {
      items: 3,
      margin: 50,
    },
    1100: {
      items: 1,
      margin: 0,
      autoWidth: false,
    },
    1200: {
      autoWidth: false,
      margin: 15,
    },
    1280: {
      items: 3,
      margin: 10,
    },
    1366: {
      items: 3,
      margin: 30,
    },
  },
};
const blogData = [
  {
    id: 1,
    blogImage: pom2089,
    blogSubImage: blogSubImage,
    blogTitle: "NFT Sales Sutge 500% on Mystery Map.",
    authorName: "MICHAELA ADAM",
    authorPosition: "GOOGLE EMPLOYEE",
  },
  {
    id: 2,
    blogImage: darlyn,
    blogSubImage: blogSubImage,
    blogTitle: "NFT Sales Sutge 500% on Mystery Map.",
    authorName: "MICHAELA ADAM",
    authorPosition: "GOOGLE EMPLOYEE",
  },
  {
    id: 3,
    blogImage: galaxy,
    blogSubImage: blogSubImage,
    blogTitle: "NFT Sales Sutge 500% on Mystery Map.",
    authorName: "MICHAELA ADAM",
    authorPosition: "GOOGLE EMPLOYEE",
  },
  {
    id: 4,
    blogImage: reckless,
    blogSubImage: blogSubImage,
    blogTitle: "NFT Sales Sutge 500% on Mystery Map.",
    authorName: "MICHAELA ADAM",
    authorPosition: "GOOGLE EMPLOYEE",
  },
];

const BlogCard = (props) => {
  const { blogD } = props;
  const {
    id,
    blogImage,
    blogTitle,
    authorName,
    authorPosition,
  } = blogD;

  return (
    <>
      <div className="s-body">
        <div className="flip-card">
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <div className="s-img">
                <img src={blogImage} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="s-details">
          <span className="user details">
            <span className="user-text">{blogTitle}</span>
          </span>

          <div className="blog-author-details">
            <img src={blogSubImage} alt="" />
            <div className="content">
              <h4>{authorName}</h4>
              <p>{authorPosition}</p>
              <a href="/" className="view-button">
                view <img src={buttonIcon} alt="arrow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const BlogCardMobile = (props) => {
  const { blogD } = props;
  const {
    id,
    blogImage,
    blogTitle,
    authorName,
    authorPosition,
  } = blogD;

  return (
    <>
      <div className="s-body">
        <div className="s-img">
          <img src={blogImage} alt="" />
        </div>
        <div className="s-details">
          <span className="user details">
            <span className="user-text">{blogTitle}</span>
          </span>
          <div className="blog-author-details">
            <img src={blogSubImage} alt="" />
            <div className="content">
              <h4>{authorName}</h4>
              <p>{authorPosition}</p>
              <a href="/" className="view-button">
                view <img src={buttonIcon} alt="arrow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


function BlogsSlider() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
      <div className="wrapper">
        <div className="slider for-desktops">
          <OwlCarousel className="artis-slider  owl-theme" {...options}>
            {blogData.map((blogD, index) => {
              return (
                  <BlogCard blogD={blogD} />
              );
            })}
          </OwlCarousel>
        </div>
        <div className="slider for-mobiles">
          <OwlCarousel className="artis-slider  owl-theme" {...options}>
            {blogData.map((blogD, index) => {
              return (
                <div key={index}>
                  <BlogCardMobile blogD={blogD} />
                </div>
              );
            })}
          </OwlCarousel>
        </div>
      </div>
  );
}

export default BlogsSlider;
